"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceResponseDto = void 0;
var InvoiceResponseDto;
(function (InvoiceResponseDto) {
    let status;
    (function (status) {
        status["DRAFT"] = "draft";
        status["OPEN"] = "open";
        status["PAID"] = "paid";
        status["UNCOLLECTIBLE"] = "uncollectible";
        status["VOID"] = "void";
    })(status = InvoiceResponseDto.status || (InvoiceResponseDto.status = {}));
})(InvoiceResponseDto || (exports.InvoiceResponseDto = InvoiceResponseDto = {}));
